import React from "react";

import AuthLayout from "../../Layouts/AuthLayout";
import CalendarComponent from "../../Components/Calendar";
import LoginForm from "./Components/LoginForm";
import SignupForm from "./Components/SignupForm";

const LoginPage = ({
  handleUser,
  userType,
  authPage,
  handleAuthPage,
  auth,
  formData,
  openCalendar,
  formUpdate,
  closeModal,
  handleCalendar
}) => {
  const isLogin = authPage?.isLogin;
  return (
    <AuthLayout
      title={isLogin ? "Sign In to your Account" : "Sign Up for an Account"}
      description={isLogin ? "Welcome back! Please enter your details." : null}
      userType={userType}
      handleUser={handleUser}
      isLogin={isLogin}
    >

      {isLogin ?
        <LoginForm
          auth={auth}
          handleAuthPage={handleAuthPage}
        /> :
        <SignupForm
          auth={auth}
          handleAuthPage=
          {handleAuthPage}
          authPage={authPage}
          formData={formData}
          handleCalendar={handleCalendar}
          openCalendar={openCalendar}
          closeModal={closeModal}
        />}

     
    </AuthLayout>
  );
};

export default LoginPage;
